export default function handleRelianceIPAOnBlueHelper(
  event,
  arrayIndex,
  formik
) {
  const { setFieldValue, values } = formik;

  const name = event.target.name;
  const value = event.target.value;

  if (
    values?.primaryDetails?.[arrayIndex]?.RelationshipWithProposerID === "345"
  ) {
    if (name === `primaryDetails[${arrayIndex}].FirstName`) {
      setFieldValue(`proposerDetails.ForeName`, value);
    } else if (name === `primaryDetails[${arrayIndex}].MiddleName`) {
      setFieldValue(`proposerDetails.MidName`, value);
    } else if (name === `primaryDetails[${arrayIndex}].LastName`) {
      setFieldValue(`proposerDetails.LastName`, value);
    }
  }
}
